import React from 'react'
import EventTable from 'components/Imports/ImportLogs/EventTable'
import QueryString from 'qs'

class MarketoImportEventLogs extends React.Component {
  render() {
    const parsedQueryString = QueryString.parse(this.props.location.search, { ignoreQueryPrefix: true })
    const jobIdFromQueryString = parsedQueryString && parsedQueryString.jobId

    // Use the query param first for backwards compatibility (https://github.com/Driftt/contacts-web/pull/353)
    const jobId = jobIdFromQueryString || this.props.match.params.jobId
    const sourceId = `marketo_sync.${jobId}`

    return (
      <EventTable sourceId={sourceId} />
    )
  }
}

export default MarketoImportEventLogs